import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import PricingCards, { CurrencySwitcher } from "@/components/PricingCards";
import FAQAccordion from "@/components/sections/FAQAccordion";
import { Reveal } from "@/components/motion";

export default function Pricing() {
  return (
    <>
      <Seo
        title="Pricing"
        description="Simple, outcome-based pricing for Stupeco WorkSpace — Starter (free), Growth, Business and Enterprise."
        path="/pricing"
      />
      <PageHeader
        eyebrow="Pricing"
        title="Priced for the value it creates."
        subtitle="One connected workspace to run and think about your business. Choose the plan that fits."
      >
        <div className="flex flex-col gap-4">
          <CurrencySwitcher />
        </div>
      </PageHeader>

      <section className="border-b border-border py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <PricingCards />
          <Reveal className="mt-10 text-center text-sm text-muted-foreground">
            Start free. Upgrade anytime — cancel or change plans without penalty.
          </Reveal>
        </div>
      </section>
      <FAQAccordion />
    </>
  );
}
